export function DealExamples() {
  const examples = [
    {
      business: 'Roseville Yoga Studio',
      deal: '50% Off First Month Membership',
      image: 'https://public.readdy.ai/ai/img_res/255038f494c6bd0be930f0d56d3c2912.jpg',
      results: '127 redemptions in 30 days',
      revenue: '$3,175 in new revenue',
      category: 'Fitness & Wellness'
    },
    {
      business: 'Main Street Pizza',
      deal: 'Buy One Get One Free Large Pizza',
      image: 'https://readdy.ai/api/search-image?query=delicious%20fresh%20pizza%20with%20melted%20cheese%20and%20toppings%20on%20wooden%20table%20in%20cozy%20restaurant%20setting%20with%20warm%20lighting%20and%20simple%20clean%20background%20highlighting%20the%20food&width=600&height=400&seq=dealex2&orientation=landscape',
      results: '243 redemptions in 30 days',
      revenue: '$4,860 in new revenue',
      category: 'Food & Dining'
    },
    {
      business: 'Roseville Auto Spa',
      deal: '$20 Off Premium Car Detailing',
      image: 'https://readdy.ai/api/search-image?query=shiny%20clean%20luxury%20car%20being%20detailed%20and%20washed%20in%20professional%20auto%20spa%20with%20modern%20equipment%20and%20clean%20bright%20environment%20with%20simple%20background%20focusing%20on%20the%20vehicle&width=600&height=400&seq=dealex3&orientation=landscape',
      results: '89 redemptions in 30 days',
      revenue: '$6,230 in new revenue',
      category: 'Automotive'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Real Results from Local Businesses
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            See how Roseville businesses are using our deals platform to attract new customers and boost revenue.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {examples.map((example, index) => (
            <div key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-xl transition-all duration-300">
              <div className="relative h-48 overflow-hidden">
                <img
                  src={example.image}
                  alt={example.business}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-4 right-4">
                  <span className="bg-emerald-500 text-white px-3 py-1 rounded-full text-xs font-bold whitespace-nowrap">
                    Success Story
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <div className="text-xs text-emerald-600 font-semibold mb-2 uppercase tracking-wide">
                  {example.category}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{example.business}</h3>
                <p className="text-gray-700 font-medium mb-4">{example.deal}</p>
                
                <div className="space-y-2 pt-4 border-t border-gray-100">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-600">Redemptions:</span>
                    <span className="text-sm font-bold text-gray-900">{example.results}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-600">New Revenue:</span>
                    <span className="text-sm font-bold text-emerald-600">{example.revenue}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 text-lg">
            Average ROI: <strong className="text-emerald-600">8.5x investment</strong> within the first 30 days
          </p>
        </div>
      </div>
    </section>
  );
}